/* eslint-disable  @typescript-eslint/no-explicit-any */
import { AbstractControl, FormArray, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { subYears } from 'date-fns';
import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';

export const mobilePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

export function password_validation(control: FormControl) {
	let password: any = control.value;
	if (password == null || password == undefined) {
		password = "";
	}
	const errObj: any = {};
	if (password.length < 8) {
		errObj.minlengtherror = true;
	}
	const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
	if (!specialChars.test(password)) {
		errObj.specialcharerror = true;
	}
	const upper = /[A-Z]/;
	const lower = /[a-z]/;
	const digit = /\d/;
	if (!upper.test(password)) {
		errObj.uppercaseerror = true;
	}
	if (!lower.test(password)) {
		errObj.lowercaseerror = true;
	}
	if (!digit.test(password)) {
		errObj.digiterror = true;
	}
	return errObj ? errObj : null;
}

export function noWhitespaceInRequiredValidator(control: FormControl) {
	const val: any = control.value;
	if (val == null) {
		return { 'required': true };
	}
	const type = typeof val;
	if (type == "number" || type == "bigint" || type == "object") {
		return null;
	}
	const isWhitespace = (control.value || '').trim().length === 0;
	const isValid = !isWhitespace;
	return isValid ? null : { 'required': true };
}

export function convertToNgbDate(date: Date): NgbDate {
	return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export const datePickerMinDate = convertToNgbDate(subYears(new Date(), 100));

/* export class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
} */

export function isImage(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
	} catch (error) {
		return false;
	}
}

export function isPdf(name: string) {
	try {
		const ext: string = name.split(".").pop() || "";
		const ext_lower = ext.toLowerCase();
		return ext_lower == "pdf";
	} catch (error) {
		return false;
	}
}

export const iconList: any = [
	{ type: "xlsx", icon: "file-excel" },
	{ type: "xls", icon: "file-excel" },
	{ type: "xlsm", icon: "file-excel" },
	{ type: "csv", icon: "file-csv" },
	{ type: "doc", icon: "file-word" },
	{ type: "docx", icon: "file-word" },
	{ type: "docm", icon: "file-word" },
	{ type: "mp4", icon: "file-video" },
	{ type: "avi", icon: "file-video" },
	{ type: "pdf", icon: "file-pdf" },
	{ type: "jpg", icon: "file-image" },
	{ type: "jpeg", icon: "file-image" },
	{ type: "png", icon: "file-image" },
	{ type: "zip", icon: "file-archive" },
	{ type: "rar", icon: "file-archive" },
	{ type: "mp3", icon: "file-audio" },
	{ type: "txt", icon: "file-alt" }
];

export const linkPattern = new RegExp('^(https?:\\/\\/)?' +
	'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
	'((\\d{1,3}\\.){3}\\d{1,3}))' +
	'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
	'(\\?[;&a-z\\d%_.~+=-]*)?' +
	'(\\#[-a-z\\d_]*)?$', 'i');

export const recurringPattern = [
	{ name: "Daily", value: "D" },
	{ name: "Weekly", value: "W" },
	{ name: "Monthly", value: "M" },
];

export class CustomDateFormatter extends CalendarDateFormatter {
	public override weekViewHour({ date, locale }: DateFormatterParams): string {
		return new Intl.DateTimeFormat(locale, {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false
		}).format(date);
	}
}

export const admin_role_name = "Admin";

export const lead_role_name = "Lead";

export const assignee_role_name = "Assignee";